import { render, staticRenderFns } from "./AlertModalComponent.vue?vue&type=template&id=548b2126&"
import script from "./AlertModalComponent.vue?vue&type=script&lang=js&"
export * from "./AlertModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertModalComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports